"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRelayNextjs = void 0;
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
const react_1 = require("react");
const react_relay_1 = require("react-relay");
const json_meta_1 = require("./json_meta");
function useRelayNextjs(props, opts) {
    const [relayEnvironment] = (0, react_1.useState)(() => {
        var _a;
        if ((_a = props.preloadedQuery) === null || _a === void 0 ? void 0 : _a.environment) {
            return props.preloadedQuery.environment;
        }
        const env = opts.createClientEnvironment();
        if (props.payload && props.payloadMeta && props.operationDescriptor) {
            (0, json_meta_1.hydrateObject)(props.payloadMeta, props.payload);
            // After SSR, during initial render (hydration), the store is empty.
            // `getInitialProps` from the server gives us data to "replay" the data
            // fetching allowing us to "hydrate" the store, ensuring the initial
            // render matches the server's.
            env.commitPayload(props.operationDescriptor, props.payload.data);
        }
        return env;
    });
    const preloadedQuery = (0, react_1.useMemo)(() => {
        if (props.preloadedQuery) {
            // During SSR and client-side navigations this will be defined.
            return props.preloadedQuery;
        }
        else if (props.operationDescriptor) {
            // During initial hydration we don't have a reference to the preloadedQuery
            // from the server because it cannot be serialized. In that case we recreate
            // it from store data.
            return (0, react_relay_1.loadQuery)(relayEnvironment, props.operationDescriptor.request.node, props.operationDescriptor.request.variables, { fetchPolicy: 'store-or-network' });
        }
        else {
            // If the page we landed on doesn't have these props defined it is not a
            // page using relay-nextjs, so we should just return undefined.
            return undefined;
        }
    }, [props, relayEnvironment]);
    return { env: relayEnvironment, preloadedQuery, CSN: props.CSN };
}
exports.useRelayNextjs = useRelayNextjs;
